/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const INSTALLATION_REPORT_URL = `${API_URL}/dailyInstallationReport`;
